import React from "react";

import './styles.scss';



const Switch = (props) => {
    return ( 
        <>
        <div className="switch" data-for={props.for}>
            <button onClick={(e) => props.handleAddClick(e)} className="off button">Add new <span className="emoji">➕</span></button>
        </div>
        <div onClick={(e) => props.handleAddClick(e)} className="overlay"></div>
        </>
        
     );
}
 
export default Switch;